
export enum NavEvent {
    ABOUT = 'about',
    GROUPS = 'groups',
    BOATS = 'boats',
    TABLE = 'table',
    IMPORT = 'import',
    EXPORT = 'export'
}

export function navEventFromString(s: string) : NavEvent {
  switch (s) {
  case NavEvent.ABOUT: return NavEvent.ABOUT;
  case NavEvent.GROUPS: return NavEvent.GROUPS;
  case NavEvent.BOATS: return NavEvent.BOATS;
  case NavEvent.TABLE: return NavEvent.TABLE;
  case NavEvent.IMPORT: return NavEvent.IMPORT;
  case NavEvent.EXPORT: return NavEvent.EXPORT;
  }
  throw new Error(`Unable to convert ${s} to NavEvent`);
}
